<template>
  <div>
    <FormulateInput
      v-if="isDisplayValue"
      type="select"
      :id="control.id"
      :name="control.name"
      :placeholder="control.placeholder"
      :help="control.help"
      :label="control.label"
      :options="control.options"
      v-model="control.value"
      :required="control.required"
    />
    <FormulateInput
      v-else
      type="select"
      :id="control.id"
      :name="control.name"
      :placeholder="control.placeholder"
      :help="control.help"
      :label="control.label"
      :options="control.options"
    />
  </div>
</template>

<script>
export default {
  props: {
    control: {
      type: Object,
      default: () => {}
    },
    isDisplayValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    value: ''
  })
}
</script>
